import { z } from 'zod';
import { passwordSchema } from './auth';
export const userRoleSchema = z.enum([
    'aiyo_admin', 'pmi_national', 'pmi_branch', 'hospital_orderer', 'hospital_finance',
    'service_admin_province', 'service_admin_city',
]);
/**
 * Role/scope consistency is validated here AND by a CHECK constraint in the database.
 * Two layers with different jobs: this one produces a human-readable error, the database
 * one guarantees no write path slips through.
 */
export const userInputSchema = z.object({
    email: z.string().trim().toLowerCase().email('Format email tidak valid'),
    name: z.string().trim().min(2, 'Nama minimal 2 karakter').max(200),
    role: userRoleSchema,
    branchId: z.string().uuid().optional().nullable(),
    hospitalId: z.string().uuid().optional().nullable(),
    serviceRegionId: z.string().uuid().optional().nullable(),
    password: passwordSchema,
    isActive: z.boolean().optional(),
}).superRefine((val, ctx) => {
    const needsBranch = val.role === 'pmi_branch';
    const needsHospital = val.role === 'hospital_orderer' || val.role === 'hospital_finance';
    const needsRegion = val.role === 'service_admin_city';
    if (needsRegion && !val.serviceRegionId) {
        ctx.addIssue({ code: 'custom', path: ['serviceRegionId'], message: 'Admin Layanan Kota wajib memilih wilayah' });
    }
    if (!needsRegion && val.serviceRegionId) {
        ctx.addIssue({ code: 'custom', path: ['serviceRegionId'], message: 'Role ini tidak boleh terikat ke wilayah' });
    }
    if (needsBranch && !val.branchId) {
        ctx.addIssue({ code: 'custom', path: ['branchId'], message: 'Role PMI Cabang wajib memilih cabang' });
    }
    if (!needsBranch && val.branchId) {
        ctx.addIssue({ code: 'custom', path: ['branchId'], message: 'Role ini tidak boleh terikat ke cabang' });
    }
    if (needsHospital && !val.hospitalId) {
        ctx.addIssue({ code: 'custom', path: ['hospitalId'], message: 'Role rumah sakit wajib memilih rumah sakit' });
    }
    if (!needsHospital && val.hospitalId) {
        ctx.addIssue({ code: 'custom', path: ['hospitalId'], message: 'Role ini tidak boleh terikat ke rumah sakit' });
    }
});
/** Updates never change the password — that is a separate path. */
export const userUpdateSchema = z.object({
    name: z.string().trim().min(2).max(200).optional(),
    isActive: z.boolean().optional(),
});
